import Icon from './icon';

export { sizes as iconSizes } from './style';
export { default as IconAnimatedChevron } from './sub-components/icon-animated-chevron';
export { type IconProps } from './icon';
export default Icon;
